export default {
  PEN: 'pen',
  ERASE: 'erase',
  HIGHLIGHTER: 'highlighter',
};
